module.exports = __webpack_public_path__ + "img/dk.7ef94bf3.png";